import styled from 'styled-components';
import { RteContentBase } from 'common/components/rte/rte.styles';

export const RteWrapper = styled.div``;

export const RteContent = styled(RteContentBase)``;
